import {
  put, select, call, takeLatest,
} from 'redux-saga/effects';
import { FILTER_REQUEST } from '../constants';
import { filterRequestSuccessAction } from '../actions';
import * as Selectors from '../selectors';
import { getTrips } from '../../../shared/api/origo';

export function* filterRequest(action) {
  const { payload } = action;
  const settings = yield select(Selectors.getSettings);
  const query = yield select(Selectors.getCurrentFilterParams);

  const { gtm } = payload;

  try {
    const result = yield call(getTrips, settings, { ...query });

    let gtmToPush = null;

    if (gtm) {
      const gtmBase = yield select(Selectors.getGTMBaseData);

      const travelHits = result.offers ? result.offers.reduce((acc, curr) => {
        return acc + curr.node.offers.length;
      }, 0) : 0;

      gtmToPush = {
        ...gtmBase,
        ...gtm,
        travelHits,
      };
    }

    yield put(filterRequestSuccessAction({ ...result }, { gtm: gtmToPush }));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Unable to filter lms departures, call got error ');
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* filterRequestSaga() {
  yield takeLatest([FILTER_REQUEST], filterRequest);
}
